/**
 * 移动端自适应public
 * 设计以iPhone6(750*1334)分辨率为基准
 * 100px=1rem(字号大小、宽高同试用)
 * 横屏竖屏同规格(注:图片等大模块最好居中显示、列表采用伸缩盒子)
 * **/

function resizeRoot() {
    let wWidth = (screen.width > 0) ? (window.innerWidth >= screen.width || window.innerWidth == 0) ? screen.width : window.innerWidth : window.innerWidth;
    let wHeight = (screen.height > 0) ? (window.innerHeight >= screen.height || window.innerHeight == 0) ? screen.height : window.innerHeight : window.innerHeight;
    let wFsize;
    if(wWidth>wHeight){
        wWidth = wHeight;
    }
    wFsize = wWidth >= 800 ? 50 : wWidth / 7.5;
    wFsize = wFsize > 32 ? wFsize : 32;
    if(wWidth == 720||wWidth==540){
        wFsize =50;
    }
    document.getElementsByTagName('html')[0].style.fontSize = wFsize + 'px';
}
resizeRoot();
window.onresize = function(){resizeRoot();}





// WEBPACK FOOTER //
// ./src/resource/js/rem.js